var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "280" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "primary" },
        [
          _c(
            "div",
            {
              staticClass:
                "primary white--text pt-2 px-2 d-flex align-center font-hemi-head",
            },
            [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _vm._v("PIANIFICA CREDITI SLOT"),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { depressed: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.dismiss()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "primary--text text--darken-3 text-center text-h4 font-weight-black mt-2",
              staticStyle: { height: "35px" },
            },
            [
              _vm.value && parseFloat(_vm.value) != 0
                ? _c("span", [_vm._v(_vm._s(parseFloat(_vm.value)))])
                : _vm.valueInitial && parseFloat(_vm.valueInitial) != 0
                ? _c("span", [_vm._v(_vm._s(parseFloat(_vm.valueInitial)))])
                : _c("span", [_vm._v("-")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-container",
            [
              _c(
                "v-row",
                { staticClass: "text-center", attrs: { "no-gutters": "" } },
                [
                  _vm._l(9, function (i) {
                    return _c(
                      "v-col",
                      { key: i, attrs: { cols: "4" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "primary white--text",
                            attrs: { depressed: "" },
                            on: {
                              click: function ($event) {
                                return _vm.insert(i)
                              },
                            },
                          },
                          [_vm._v(_vm._s(i))]
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "white--text",
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clear()
                            },
                          },
                        },
                        [_vm._v("CANC")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary white--text",
                          attrs: { large: "", depressed: "" },
                          on: {
                            click: function ($event) {
                              return _vm.insert(0)
                            },
                          },
                        },
                        [_vm._v("0")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "white--text",
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.backspace()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("backspace")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { staticClass: "mt-2", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            large: "",
                            block: "",
                            color: "secondary",
                            loading: _vm.processing,
                            disabled: !parseFloat(_vm.value) || _vm.error,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.salva()
                            },
                          },
                        },
                        [_vm._v("\n            Salva\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.error
            ? _c("div", { staticClass: "px-2 error white--text text-center" }, [
                _vm._v("\n      " + _vm._s(_vm.error) + "\n    "),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }